import { text as sharedText } from '@shared/text';

export const text = {
  sowWeekSelectOptions(): Array<{ value: string; label: string }> {
    return ([1, 2, 3, 4] as const).map((week) => ({
      value: String(week),
      label: String(week),
    }));
  },

  sowMonthSelectOptions(): Array<{ value: string; label: string }> {
    return sharedText.months.map((label, index) => ({
      value: String(index + 1),
      label: label.slice(0, 3),
    }));
  },
};
